<div class="main-box">
    <div [formGroup]="schoolForm">
        <p-button label="Submit" (onClick)="sendForm()"></p-button>
        <p *ngIf="nameIsNull">
          school name is required
        </p>
      <table>
        <tr>
            <td>
                School name
              </td>
              <td>
                  <input pInputText placeholder="Name" type="text" formControlName="name">
              </td>
        </tr>
        <tr>
          <td>
            Public name
          </td>
          <td>
            <input pInputText formControlName="externalName">
          </td>
        </tr>
        <tr>
          <td>Country
            <p-button label="add" (onClick)="addCountry()"></p-button>
          </td>
          <td>
            <div *ngFor="let country of formData.controls; index as i">
              <p-dropdown [formControl]="country | formControl" placeholder="Select Country" [options]="itemGroups" [group]="true" scrollHeight="420px"></p-dropdown>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            Programme type
            <p-button label="add" (onClick)="addProgrammeType()"></p-button>
          </td>
          <td>
            <div *ngFor="let programmeType of programmeTypeFormData.controls; index as i">
              <p-dropdown [formControl]="programmeType | formControl" placeholder="Select Programme type" [options]="programmeTypes" 
              optionLabel="name"></p-dropdown>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            Comment
          </td>
          <td>
            <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
          </td>
        </tr>
      </table>
      </div>
</div>
